import type * as React from 'react';
import type { Interpolation, SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

type IconVariant = 'default' | 'negative' | 'positive' | 'primary' | 'warning';

export type IconWrapperProps = React.ComponentPropsWithoutRef<'span'> & {
  customCss?: Interpolation<Theme>;
  variant?: IconVariant;
};

const S = {
  iconWrapper: (theme: Theme, variant?: IconVariant): SerializedStyles => css`
    display: inline-flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: ${variant ? (variant === 'default' ? theme.palette.text.body : theme.palette[variant].main) : 'inherit'};
  `,
};

// Wraps every `@svg` icon (see svg/svg-template.js)
const IconWrapper = ({ customCss, variant, ...rest }: IconWrapperProps) => (
  <span css={(theme) => [S.iconWrapper(theme, variant), customCss]} {...rest} />
);

IconWrapper.displayName = 'IconWrapper';

export default IconWrapper;
